export default __webpack_public_path__ + "static/media/sl2.2d37a223.svg";